import $ from 'jquery';
import './map';
import intlTelInput from 'intl-tel-input';

require('bootstrap');
require('slick-carousel');
require('lightbox2');
require('select2');

// Load Dependencies...
import lozad from 'lozad';
window.Lozad = lozad(); // lazy loads elements with default selector as '.lozad'
window.Lozad.observe();

var scroll=new SmoothScroll('a[href*="#"]',{
    speed:600,
    offset:200,
    easing:"easeInOutCubic",
    updateURL: false
});

new SmoothScroll('a[data-scroll-600]',{
    speed:600,
    offset:0,
    easing:"easeInOutCubic",
    updateURL: false
});


// Example starter JavaScript for disabling form submissions if there are invalid fields
(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                var this_form_buttons = $(form).find(":button,:submit");
                // Disable this form's buttons
                this_form_buttons.prop({"disabled":true,"title":"Processing..."}).addClass("disabled");
                if (form.checkValidity() === false) {
                    // Form not validated: re-enable this form's buttons
                    this_form_buttons.prop({"disabled":false,"title":""}).removeClass("disabled");
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

$(document).ready(function()
{
    var nav_height = $('.navbar').height();

    $('.development-hero').css('margin-top', nav_height);

    $('.button-click').on('click', function()
    {
        // Remove If Already Exists...
        $('#button-value').remove();

        var button_value = $(this).data('button-text');

        $('#developmentenquiry').append('<input type="hidden" id="button-value" name="button" value="' + button_value + '" />');
    })

})

//INTL Tel Input..
if ($('.intTel').length) {
    if($('#preferred_countries').length) {
        var input = document.querySelector("#phone");
        var preferred_countries = document.querySelector('#preferred_countries').value.split(",");
        if(input !== null) {
            var telephone_input = intlTelInput(input, {
                initialCountry: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries[0] : 'GB',
                preferredCountries: ["gb","ie","be", "dk", "no", "se"],
                allowExtensions: true,
                autoFormat: false,
                autoHideDialCode: false,
                autoPlaceholder: false,
                defaultCountry: "ae",
                ipinfoToken: "yolo",
                nationalMode: false,
                numberType: "MOBILE",
                preventInvalidNumbers: true
            });
        }
    }

    var dc = document.querySelector("#dialcode");
    var updateDialCode = function() {
        var countryData = telephone_input.getSelectedCountryData();
        if(dc) {
            dc.value = countryData.dialCode;
        }
    };
    if(input !== null) {
        input.addEventListener("countrychange", updateDialCode);
        updateDialCode();
    }

    var dc_input = document.querySelector("#phone_popup");
    if(dc_input !== null) {
        var dc_popup = document.querySelector("#dialcode_popup");
        var dcTel_input = intlTelInput(dc_input, {
            initialCountry: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries[0] : 'GB',
            preferredCountries: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries : ["gb","ie","be", "dk", "no", "se"],
            allowExtensions: true,
            autoFormat: false,
            autoHideDialCode: false,
            autoPlaceholder: false,
            defaultCountry: "ae",
            ipinfoToken: "yolo",
            nationalMode: false,
            numberType: "MOBILE",
            preventInvalidNumbers: true
        });

        var updateDialCodePopup = function() {
            var countryData = dcTel_input.getSelectedCountryData();
            if(dc_popup) {
                dc_popup.value = countryData.dialCode;
            }
        };

        dc_input.addEventListener("countrychange", updateDialCodePopup);
        updateDialCodePopup();
    }
}

$("#developmentenquiry").on('submit',function(e)
{
    $('#fullnumber').val('+' + telephone_input.getSelectedCountryData().dialCode + $('#phone').val());
});

$('.hero-menu').on('click', 'a', function(e) {
    e.preventDefault();
    var elem = $(this),
        t = $(elem.attr('href'));

    if(t.length) {
        // $('html, body').animate({ scrollTop: t.offset().top }, 600);
    } else {
        window.location.href = elem.attr('href');
    }

    return false;
});

if($('.testimonials-slick').length) {
    $('.testimonials-slick').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>'
    });
}

if($('.highlights-gallery').length) {
    $('.highlights-gallery').slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear'
    });
}

if($('.slick-center').length) {
    $('.slick-center').slick({
        centerMode: true,
        dots: true,
        infinite: true,
        centerPadding: '200px',
        slidesToShow: 1,
        appendArrows: '.slick-center-nav',
        appendDots: '.slick-center-nav',
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '40px',
                }
            }
        ]
    });
}

let singleDevelopmentTemplate2HeroSlider = $('.single-development-template-2 .hero-slider');

if (singleDevelopmentTemplate2HeroSlider.length) {
    singleDevelopmentTemplate2HeroSlider.slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.single-development-template-2 .hero-slider-container .hero-slider-nav').removeClass('active');
        $(`.single-development-template-2 .hero-slider-container .hero-slider-nav[data-slide=${nextSlide}]`).addClass('active');
        $('.single-development-template-2 .hero-slider-container .current-slide-indicator').text(String(nextSlide + 1).padStart(2, '0'));
    });

    $('.single-development-template-2 .hero-slider-container .hero-slider-nav').on('click', function(e) {
        e.preventDefault();
        let $this = $(this);
        let slide = $this.data('slide');
        $('.single-development-template-2 .hero-slider-container .single-development-template-2 .hero-slider-nav').removeClass('active');
        $this.addClass('active');
        singleDevelopmentTemplate2HeroSlider.slick('slickGoTo', slide);
        $('.single-development-template-2 .hero-slider-container .current-slide-indicator').text(String(slide + 1).padStart(2, '0'));
    });
}

let propertyShowcaseSlider = $('.property-showcase-slider');

if (propertyShowcaseSlider.length) {
    propertyShowcaseSlider.slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
        nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>'
    }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
}

$('.select2-client-pages').select2(
    {
        minimumResultsForSearch: -1,
    }
);

/**
 * Listen to scroll to change header opacity class
 */
 function checkScroll(){
    var startY = $('.navbar').height() * 2; //The point where the navbar changes in px

    if($(window).scrollTop() > startY){
        $('.navbar').addClass("scrolled");
    }else{
        $('.navbar').removeClass("scrolled");
    }
}

if($('.navbar').length > 0){
    $(window).on("scroll load resize", function(){
        checkScroll();
    });
}

//----------------------------------------------------
// Development Page Functions
//----------------------------------------------------

function propertyCardImageSlider(){
    var target = $('.property-card .property-images .property-slider');
    
    if(target.length) {
        target.each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                dots: false,
                autoplay: false,
                autoplaySpeed: 3000,
                prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
                nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>'
            })
        })
    }
}

function propertyCardPriceRangeScroll(){
    var target = $('.btn-pricerange-cta');
    
    if(target.length) {
        
        target.each(function () {

            // check if cards exist for pricerange and hide button if not
            var pricerange = $(this).data('pricerange');
            var cardExists = $('.property-card[data-pricerange="' + pricerange + '"]').length > 0;
            
            if (!cardExists) {
                $(this).addClass('hidden');
            }

            // scroll to card
            $(this).on('click', function(e) {
                e.preventDefault();
                
                var pricerange = $(this).data('pricerange');
                var card_target = $( '.property-card[data-pricerange="' + pricerange + '"]');
                var scroll_top = card_target.length ? card_target.offset().top - $('header nav').height() - 20 : $('.development-properties-section').offset().top - $('header nav').height() - 20;

                $('html, body').animate({
                    scrollTop: scroll_top
                }, 2000);
            })
        })
    }
}

function propertyCardFilterByPropertyTypes(){

    var target = $('.development-properties-section .property-types-list li button');
    
    if(target.length) {
        
        target.each(function () {

            var propertyType = $(this).data('propertytype');
            var cardExists = $('.property-card[data-propertytype="' + propertyType + '"]').length > 0;
            
            // hide property types that don't have cards
            if (cardExists || propertyType == 'all') {
                $(this).closest('li').removeClass('hidden');
            }

            // filter cards by property type
            $(this).on('click', function(e) {
                e.preventDefault();

                target.removeClass('active');
                $(this).addClass('active');


                var propertyType = $(this).data('propertytype');
                $('.development-properties-section .property-card').closest('.col-property').addClass('hidden');
                $('.development-properties-section .property-card[data-propertytype="' + propertyType + '"]').closest('.col-property').removeClass('hidden');

                if(propertyType == 'all') {
                    $('.development-properties-section .property-card').closest('.col-property').removeClass('hidden');
                }
            })
        })
    }
}

function customModal(){

    var target = $('.custom-modal-container ');
    
    if(target.length) {

        target.each(function () {

            var $modalContainer = $(this);

            $modalContainer.find('.close-btn').on('click', function() {
                const $modal = $(this).closest('.modal');
                $modal.removeClass('active');
                $('body').css('overflow', ''); // Restore scrolling
            });
            
            // Close modal
            $modalContainer.find('.close-btn').on('click', function() {
                const $modal = $(this).closest('.modal');
                $modal.removeClass('active');
                $('body').css('overflow', ''); // Restore scrolling
            });
    
            // Close modal on backdrop click
            $modalContainer.find('.modal').on('click', function(e) {
                if ($(e.target).hasClass('modal')) {
                $(this).removeClass('active');
                $('body').css('overflow', ''); // Restore scrolling
                }
            });
    
            // Trap focus within modal
            $modalContainer.find('.modal').on('keydown', function(e) {
                if (e.key === 'Tab' && $(this).hasClass('active')) {
                const $focusable = $(this).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
                const $first = $focusable.first();
                const $last = $focusable.last();
    
                if (e.shiftKey && $(document.activeElement).is($first)) {
                    e.preventDefault();
                    $last.focus();
                } else if (!e.shiftKey && $(document.activeElement).is($last)) {
                    e.preventDefault();
                    $first.focus();
                }
                }
            });

        });

        // Open modal
        $('.open-modal').on('click', function(e) {
            e.preventDefault();
            const modalId = $(this).data('modal');
            const propertyid = $(this).data('propertyid');
            const propertyname = $(this).data('propertyname');
            const $modal = $('#' + modalId);
            $modal.addClass('active');
            $modal.find('.modal-content').attr('tabindex', '-1').focus(); // Mimic Bootstrap focus
            $modal.find('#property_id').val(propertyid);
            $modal.find('#propertyname').text(propertyname);
            $('body').css('overflow', 'hidden'); // Prevent scrolling
        });
        
    }
}

function developmentAreasSlider(){
    var target = $('.development-areas-slider');
    
    if(target.length) {
        target.slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
            nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        })
    }
}

//----------------------------------------------------
// endof :: Development Page Functions
//----------------------------------------------------


(function ($) {

    function formNavigateAlert() {

        var target = $('.alert-form_error');

        if (target.length) {

            $('html, body').animate({
                scrollTop: $( '#contact-form-section' ).offset().top
            }, 2000);

        }
    }

    $(document).ready(function () {

        $('a.linkSlide').on('click', function(e) {
            e.preventDefault();
            var target = $($(this).attr('href'));

            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 2000);
            }
        });

        formNavigateAlert();
        // propertyCardImageSlider();
        // propertyCardPriceRangeScroll();
        // propertyCardFilterByPropertyTypes();
        // customModal();
        // developmentAreasSlider();

    });

}(window.jQuery || window.$));

import './development';
import './development-map';
import './behavioral-overlays';